type UserNameParts =
  | {
      firstName?: string | null;
      lastName?: string | null;
    }
  | null
  | undefined;

export function getUserDisplayName(user: UserNameParts): string {
  if (!user) return '';

  const fullName = [user.firstName, user.lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');

  return fullName || 'user';
}
